import styled from 'styled-components'
import { Chiclet as Chl, Link } from 'components'

const Chiclet = styled(Chl)`
${({ theme: { colors } }) => `
  color: ${colors('text')} !important;
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 1.5rem;

&.close{
  background: ${colors('text')};
  color: ${colors('background')};
  display: flex;
  font-size: 1rem;
  align-items: center;
  justify-content: center;
  `}
}
`

const PostContainer = styled.div`
  position: absolute;
  right: 1rem;
  bottom: 5rem;
  width: calc(100% - 2rem);
  z-index: 99999;
`

export const PostChiclet = ({ postable_id, postable_type }) => {
  return (
    <>
      <PostContainer>
        <Link to={`/post/${postable_type}/${postable_id}/post`}>
          <Chiclet color="link">+</Chiclet>
        </Link>
      </PostContainer>
    </>
  )
}
